export class BlockItemFlatNode {
  item: string;
  level: number;
  uuid: string;
  index: string;
  expandable: boolean;
  type: string;
}
